// A class's manage page opened on its Exams tab from an exam's pages
// (byj-1wv.51.12, byj-1wv.51.20): the key its tab is kept under per browser,
// and the opening itself — so those pages do not import the manage page.
import { keep } from "./kept";
import { navigate } from "./router";

/** The key the manage page keeps its tab under, per browser. */
export const ClassManageTabKey = "class-manage.tab";

/** A class's manage page opened on its Exams tab, from an exam's pages (byj-1wv.51.12): the tab kept is the one it opens on. */
export function openClassExams(classId: string) {
  keep(ClassManageTabKey, "exams");
  navigate(`/c/${encodeURIComponent(classId)}/manage`);
}
